import React from 'react';
import Skeleton from './Skeleton';

interface ProductSkeletonLoaderProps {
  count?: number;
}

export const ProductSkeletonLoader: React.FC<ProductSkeletonLoaderProps> = ({ count = 3 }) => (
  <div className="product-grid">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="product-card" style={{ pointerEvents: 'none' }}>
        <div className="product-image-container">
          <Skeleton height={200} width="100%" />
        </div>
        <div className="product-content">
          <Skeleton height={24} width="80%" />
          <Skeleton height={14} width="100%" count={2} />
          <div style={{ marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <Skeleton height={24} width={60} borderRadius={20} />
            <Skeleton height={24} width={60} borderRadius={20} />
            <Skeleton height={24} width={60} borderRadius={20} />
          </div>
        </div>
      </div>
    ))}
  </div>
);
